// One idempotency key per attempt at a write (QA-058). An attempt is one try at one thing: opening a
// dialog and confirming it, or writing a note and sending it. Trying it again after a lost answer sends
// the same key, so the server does it once. A changed input is a new attempt (the server refuses a key
// used again for a different request), and so is the next one after a success or a closed dialog.
// useSaveKey (SaveButton.tsx) holds one of these for a form; the job page holds one per write.

import { newId } from './ids.ts';

export interface AttemptKeys {
  /** The attempt's key: the same while `signature` (what it sends) stays the same. */
  key(attempt: string, signature: string): string;
  /** It succeeded, or its dialog closed: the next try is a new attempt with a new key. */
  end(attempt: string): void;
}

export function attemptKeys(make: () => string = newId): AttemptKeys {
  const held = new Map<string, { signature: string; key: string }>();
  return {
    key(attempt, signature) {
      const h = held.get(attempt);
      if (h && h.signature === signature) return h.key;
      const key = make();
      held.set(attempt, { signature, key });
      return key;
    },
    end(attempt) {
      held.delete(attempt);
    },
  };
}
